// extracted by mini-css-extract-plugin
export var addToCartButton = "_qi-b";
export var arrowButtonContainer = "_qi-9";
export var arrowButtonIcon = "_qi-a";
export var carouselArrowButton = "_qi-6";
export var carouselElementContainer = "_qi-1";
export var left = "_qi-7";
export var productDisplayCarouselContainer = "_qi-0";
export var productTileContainer = "_qi-2";
export var productTileImage = "_qi-4";
export var productTileImageContainer = "_qi-3";
export var productTileTitle = "_qi-5";
export var right = "_qi-8";
export var sliderOverflow = "_qi-c";